/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { makeStyles } from "@material-ui/core";

export const useDrawerContentV1Styles = makeStyles((theme) => {
    return {
        root: {
            maxWidth: 400,
            backgroundColor: theme.palette.background.default,
        },
    };
});
